export default {
    'ua': {
        'label': 'UA',
        'flag': '../images/flags/ua.png',
        'value': 'ua',
        'name': 'Ukrainian'
    },
    'en': {
        'label': 'EN',
        'flag': '../images/flags/uk.png',
        'value': 'en',
        'name': 'English'
    },
    'ru': {
        'label': 'RU',
        'flag': '../images/flags/ru.png',
        'value': 'ru',
        'name': 'Russian'
    },
}
